import { createSlice } from "@reduxjs/toolkit";

const initialNotification = {
    show: false,
    text: "",
    type: ""
}

const notification = createSlice({
    name: "notification",
    initialState: initialNotification,
    reducers: {
        changeNotification(state, action) {
            state.show = action.payload.show;
            state.text = action.payload.text;
            state.type = action.payload.type;
        }
    }
})

export const notificationActions = notification.actions;

export default notification.reducer